import React from "react";
import "./brand.css";

const brands = [
   {
    name: "ACC Cement",
    className: "acc",
    logo: require("../../images/Acc.png").default,
  },
  {
    name: "UltraTech Cement",
    className: "ultratech",
    logo: require("../../images/ultratech-logo.png").default,
  },
   {
    name: "Jaquar",
    className: "jaquar",
    logo: require("../../images/jaquar.png").default,
  },
  {
    name: "Kajaria",
    className: "kajaria",
    logo: require("../../images/kajaria-logo.png").default,
  },
  {
    name: "Dr. Fixit",
    className: "dr-fixit",
    logo: require("../../images/fixit.png").default,
  },
  { name: "Legrand", className: "legrand", mark: "legrand" },
  {
    name: "Schneider Electric",
    className: "schneider",
    logo: require("../../images/schneider-logo.webp").default,
  },
];

const Brands = () => {
  return (
    <section className="brand-section">
      <div className="brand-heading">
        <p className="brand-kicker">
          <span className="brand-kicker__line" />
          QUALITY
          <span className="brand-kicker__line" />
        </p>
        <h2>
          Brands <b>We Use</b>
        </h2>
        <p>We partner with trusted brands to deliver lasting quality.</p>
      </div>

      <div className="brand-grid">
        {brands.map((brand) => (
          <div className="brand-card" key={brand.name}>
            {brand.logo ? (
              <img
                className={`brand-card__logo brand-card__logo--${brand.className}`}
                src={brand.logo}
                alt={brand.name}
              />
            ) : (
              <div
                className={`brand-card__mark brand-card__mark--${brand.className}`}
                aria-label={brand.name}
              >
                {brand.mark}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Brands;
